import { execute } from '@/api/execute'
import { GET } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

const ENDPOINT = 'dashboard/perm/groups'

export default {
  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  permissions () {
    return execute(GET, 'dashboard/perm/permissions/')
  }
}
